<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">

    <side-bar>
      <mobile-menu slot="content"> </mobile-menu>
      <sidebar-link to="/dashboard">
        <md-icon>dashboard</md-icon>
        <p>Overview</p>
      </sidebar-link>
      <sidebar-link to="/dashboard/outlet">
        <md-icon>store</md-icon>
        <p>Manage Outlet</p>
      </sidebar-link>
      <sidebar-link to="/dashboard/offers">
        <md-icon>tag</md-icon>
        <p>Offers</p>
      </sidebar-link>
      <sidebar-link to="/dashboard/privacy">
        <md-icon>bubble_chart</md-icon>
        <p>Privacy Policy</p>
      </sidebar-link>
      <sidebar-link v-bind:onclick="signout" to="/dashboard/end">
        <md-icon v-bind:onclick="signout">logout</md-icon>
        <p v-bind:onclick="signout">Log Out</p>
      </sidebar-link>
      <sidebar-link to="/dashboard/privacy" class="active-pro">
        <md-icon>copyright</md-icon>
        <p>Blink Offer 2019</p>
      </sidebar-link>
    </side-bar>

    <div class="main-panel">
      <div v-show="loading"
        class="text-center md-alignment-center load md-danger">

        <pulse-loader :loading="loading" :color="color" > </pulse-loader>

      </div>

      <top-navbar> </top-navbar>

      <dashboard-content> </dashboard-content>

    </div>
  </div>
</template>

<style lang="scss" scoped>
  .load {
    margin: 4px;
  }
</style>

<script>
import TopNavbar from "./TopNavbar.vue";
import DashboardContent from "./Content.vue";
import MobileMenu from "@/pages/Layout/MobileMenu.vue";
import firebase from "../../Firebase";
import PulseLoader from 'vue-spinner/src/PulseLoader.vue';

export default {
  components: {
    TopNavbar,
    DashboardContent,
    MobileMenu,
    PulseLoader
  }, data() {
    return {
      loading: true,
      color : "purple",
      amount: 50
    };
  },
  created() {
    firebase.auth().onAuthStateChanged(user => {
      if (!user) {
          window.location.href = "";
      } else {
        let db = firebase.firestore().collection("sellers").doc(user.uid);
        db.get().then(doc => {
          if (!doc.exists) {
            db.set({
              uid: user.uid,
              email: user.email,
              joined: new Date(),
              setup: 0
            }).then(value => {
              console.log(value);
              window.location.href = "#/dashboard/outlet";
              this.loading = false;
            });
          } else {
              if (doc.data()['setup'] < 2)
                  window.location.href = "#/dashboard/outlet";
              this.loading = false;
          }
        });
      }
    });
  },
  methods: {
    signout() {
      alert("Do you really want to sign out?");
    }
  }
};
</script>
